export default {
    ja: {
        other: {
            heading: 'OTHER EVENT',
            caption: '現在開催中・近日開催予定のイベント',
            description: 'お得に買える早割チケットも好評発売中！京都周辺のイベントをご紹介しています。',
            readMore: '続きを読む',
            close: '閉じる',
            external: '公式サイト',
            items: [
                {
                    subtitle: '京都 二条城',
                    title: '本丸御殿公開記念 NAKED meets 二条城 2024 秋の豊穣祭',
                    description: '2024年10月25日(金)〜12月8日(日)',
                    showTitle: true,
                    showSubtitle: true,
                    link: 'https://event.naked.works/nijojo/autumn/'
                },
                {
                    subtitle: '滋賀 比叡山坂本',
                    title: 'NAKED夜さんぽ™ 比叡山坂本',
                    description: '2024年11月1日(金)〜12月8日(日)',
                    showTitle: true,
                    showSubtitle: true,
                    link: 'https://garden.naked.works/kyoto/spot/hieizan_sakamoto_area_2024/'
                },
                {
                    subtitle: '名古屋',
                    title: 'NAKED 天空のお月見 2024 中部電力 MIRAI TOWER',
                    description: '2024年9月24日（火）～ 2024年11月24日（日）',
                    showTitle: true,
                    showSubtitle: true,
                    link: 'https://www.nagoya-tv-tower.co.jp/nakedinc/'
                },
                {
                    subtitle: '滋賀 比叡山延暦寺',
                    title: '西塔釈迦堂　秘仏本尊釈迦如来像特別ご開帳・内陣特別公開',
                    description: '2024年9月14日(土)〜12月8日(日)',
                    showTitle: true,
                    showSubtitle: true,
                    link: 'https://garden.naked.works/kyoto/spot/hieizan_enryakuji_temple_2024/'
                },
            ],
        },
    },
    en: {
        other: {
            heading: 'OTHER EVENT',
            caption: 'Current & Upcoming Events',
            description: 'Early-bird tickets are now on sale for a discount! We introduce events around Kyoto.',
            readMore: 'Show more',
            close: 'Close',
            external: '公式サイト',
            items: [
                {
                    subtitle: 'Kyoto Former Imperial Villa Nijo-jo Castle',
                    title: 'Commemorating the Opening of Honmaru-Goten Palace\n'+'NAKED meets Nijo-jo Castle 2024 Autumn Harvest Festival',
                    description: 'October 25 (Fri) - December 8 (Sun), 2024',
                    showTitle: true,
                    showSubtitle: true,
                    link: 'https://event.naked.works/nijojo/autumn/en/'
                },
                {
                    subtitle: 'Shiga Hieizan Sakamoto',
                    title: 'NAKED\'s night walk Hieizan Sakamoto',
                    description: 'November 1 (Fri) - December 8 (Sun), 2024',
                    showTitle: true,
                    showSubtitle: true,
                    link: 'https://garden.naked.works/en/kyoto/spot/hieizan_sakamoto_area_2024/'
                },
                {
                    subtitle: 'Nagoya',
                    title: 'NAKED Moon Viewing in the Sky 2024: Chubu Electric Power MIRAI TOWER',
                    description: 'September 24 (Tue) - November 24 (Sun), 2024',
                    showTitle: true,
                    showSubtitle: true,
                    link: 'https://www.nagoya-tv-tower.co.jp/nakedinc/'
                },
                {
                    subtitle: 'Shiga Hieizan Enryakuji Temple',
                    title: 'Special opening of the statue of Shakyamuni Nyorai, the principal image of the hidden Buddha in the West Pagoda Shakyamuni Hall and special opening of the inner sanctuary',
                    description: 'September 14 (Sat) - December 8 (Sun), 2024',
                    showTitle: true,
                    showSubtitle: true,
                    link: 'https://garden.naked.works/kyoto/spot/hieizan_enryakuji_temple_2024/'
                },
            ],
        },
    },


}